import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { auctionsLabels } from "@/i18n/labels/auctionsLabels";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { useState, KeyboardEvent } from "react";

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
  hasActiveSearch?: boolean;
  onClearSearch?: () => void;
  autoFocus?: boolean;
}

const SearchBar = ({ searchTerm, onSearchChange, onSearch, hasActiveSearch = false, onClearSearch, autoFocus }: SearchBarProps) => {
  const { theme } = useTheme();
  const { language } = useLanguage();
  const labels = auctionsLabels(language);
  const isDark = theme === "dark";

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="relative flex-1 flex gap-2">
      <div className="relative flex-1">
        <Search
          className={`absolute left-3 top-1/2 transform -translate-y-1/2 text-primary/60 w-3 h-3 md:w-4 md:h-4`}
        />
        <Input
          placeholder={labels.searchBar.placeholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyDown={handleKeyDown}
          autoFocus={autoFocus}
          className={`pl-10 bg-card placeholder:text-primary/60`}
        />
      </div>
      {hasActiveSearch && onClearSearch && (
        <Button
          onClick={onClearSearch}
          variant="outline"
          className="px-4 md:px-6"
        >
          <X className="w-4 h-4 mr-1" />
          {labels.searchBar.clear}
        </Button>
      )}
      <Button
        onClick={onSearch}
        className="px-4 md:px-6"
      >
        {labels.searchBar.search}
      </Button>
    </div>
  );
};

export default SearchBar;
